// shabba-dashboard/src/utils/book.ts

import { BookLevel, BookSide, BookState } from '../types';

export function cloneBookSide(side: BookSide): BookSide {
  return new Map(side);
}
export function keyForEntry(e: any) {
  return e.id ?? `px:${e.price}`;
}

export function applySnapshot(prev: BookState, entries: any[]): BookState {
  const bids: BookSide = new Map();
  const asks: BookSide = new Map();

  for (const e of entries) {
    if ((e.type === "0" || e.type === "1") && Number.isFinite(e.price) && Number.isFinite(e.size)) {
      const k = keyForEntry(e);
      const level = { price: e.price, size: e.size, id: e.id } as BookLevel;
      (e.type === "0" ? bids : asks).set(k, level);
    }
  }
  if (bids.size === 0 && asks.size === 0) return prev;
  return { bids, asks };
}

export function applyIncremental(prev: BookState, entries: any[]): BookState {
  const next: BookState = { bids: cloneBookSide(prev.bids), asks: cloneBookSide(prev.asks) };
  for (const e of entries) {
    if (e.type !== "0" && e.type !== "1") continue;
    const side = e.type === "0" ? next.bids : next.asks;
    const k = keyForEntry(e);
    const action = e.action ?? "1"; // 0=New, 1=Change, 2=Delete

    if (action === "0") {
      if (e.price != null && e.size != null && e.size > 0) {
        side.set(k, { price: e.price, size: e.size, id: e.id });
      }
    } else if (action === "1") {
      const curr = side.get(k);
      if (curr) {
        const newSize = e.size ?? curr.size;
        if (newSize > 0) {
          side.set(k, { price: e.price ?? curr.price, size: newSize, id: e.id ?? curr.id });
        } else {
          side.delete(k);
        }
      } else if (e.price != null && e.size != null && e.size > 0) {
        side.set(k, { price: e.price, size: e.size, id: e.id });
      }
    } else if (action === "2") {
      side.delete(k);
    }
  }
  return next;
}

export function bookToArrays(book: BookState) {
  const bids = Array.from(book.bids.values())
    .filter(l => l.size > 0)
    .sort((a, b) => b.price - a.price)
    .slice(0, 20);

  const asks = Array.from(book.asks.values())
    .filter(l => l.size > 0)
    .sort((a, b) => a.price - b.price)
    .slice(0, 20);

  return { bids, asks };
}

export function bestPrices(book: BookState) {
  let bestBid = -Infinity, bestAsk = Infinity;

  book.bids.forEach((l) => {
    if (l.size > 0 && l.price > bestBid) bestBid = l.price;
  });
  book.asks.forEach((l) => {
    if (l.size > 0 && l.price < bestAsk) bestAsk = l.price;
  });

  const bid = Number.isFinite(bestBid) ? bestBid : undefined;
  const ask = Number.isFinite(bestAsk) ? bestAsk : undefined;
  const mid = bid != null && ask != null ? (bid + ask) / 2 : (bid ?? ask);
  return { bid, ask, mid };
}
